import { render, staticRenderFns } from "./ImagesRoundedCorner.vue?vue&type=template&id=00edf8aa&"
import script from "./ImagesRoundedCorner.vue?vue&type=script&lang=js&"
export * from "./ImagesRoundedCorner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports